import { isClient } from 'shared/utils/common'

import { mobileBreakPoint } from './breakpoints'

export const getNavHeight = ({
  ribbonHeight,
  topNavHeight,
  isRibbonVisible
}: {
  ribbonHeight: number
  topNavHeight: number
  isRibbonVisible: boolean
}) => {
  return topNavHeight + (isRibbonVisible ? ribbonHeight : 0)
}

export const isMobileView = () =>
  typeof window !== 'undefined' &&
  window.matchMedia(`(max-width: ${mobileBreakPoint}px)`).matches

export const getWebSourceFromNavigator = (): 'web' | 'mobile-web' => {
  if (typeof navigator === 'undefined') return 'web'

  const userAgent = navigator.userAgent || ''
  const isMobileUA =
    /Mobi|Android|iPhone|iPod|iPad|Windows Phone|BlackBerry/i.test(userAgent)

  return isMobileUA ? 'mobile-web' : 'web'
}

const getScrollbarWidth = (): number =>
  window.innerWidth - document.documentElement.clientWidth

export const lockBodyScroll = () => {
  if (!isClient()) return

  const body = document.body
  const scrollbarWidth = getScrollbarWidth()

  body.style.overflow = 'hidden'

  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`
  }
}

export const unlockBodyScroll = (original: {
  overflow?: string
  paddingRight?: string
}) => {
  if (!isClient()) return

  const body = document.body

  body.style.overflow = original.overflow ?? ''
  body.style.paddingRight = original.paddingRight ?? ''
}

export const isElementVisible = (element: HTMLElement) => {
  const style = window.getComputedStyle(element)

  if (style.display === 'none' || style.visibility === 'hidden') return false

  return element.getClientRects().length > 0
}
